import { ACTIONS } from './types';
import { caseInsensitiveInclude } from '../helpers/utils';

export const setFilteredEmergenciesAction = () => (dispatch, getState) => {
    const { filters: { search, showFinished, showTest }, allEmergencies, selectedEmergency } = getState();
    let filteredEmergencies = [ ...allEmergencies ];
    if (search) {
        filteredEmergencies = filteredEmergencies.filter(
            e => caseInsensitiveInclude(e?.user?.medicalCard?.firstName, search) ||
                caseInsensitiveInclude(e?.user?.medicalCard?.lastName, search) ||
                caseInsensitiveInclude(e?.state ?? '', search) ||
                e?.user?.phone?.includes(search)
        );
    }

    filteredEmergencies = showFinished ?
        filteredEmergencies : filteredEmergencies.filter(em => em.status !== 'finished');

    filteredEmergencies = showTest ?
        filteredEmergencies : filteredEmergencies.filter(em => em.finishReason !== 'Хибний/тестовий виклик');

    dispatch({
        type: ACTIONS.SET_FILTERED_EMERGENCIES,
        payload: filteredEmergencies
    });

    if (!(selectedEmergency && filteredEmergencies.find(e => e.id === selectedEmergency.id))) {
        dispatch({ type: ACTIONS.CLEAR_SELECTED_EMERGENCY });
    }
}
